<div class="emd-container">
    <div class="emd-container__header section-header" style="min-height: 0em; padding: 9px">
        <h2 class="emd-text _type_caption" style="font-size: 1rem">{{ title }}</h2>
        <span *ngIf="isLoading" class="spinner-border section-loader"></span>
    </div>
    <div
        [ngClass]="{
            'app-custom-scrollbar': useHorizontalScroll,
            scrollable: useHorizontalScroll,
            section: !sectionStyle
        }"
        [ngStyle]="sectionStyle ? sectionStyle : {}"
    >
        <ng-content></ng-content>
    </div>
</div>
